import { UserAccount } from '@data-types';
import { UserAccountType } from '@common/constants/UserAccountType';
import { isGamesTheme } from '@utils';
import { UserAuthStore } from '@state/shared';
import { THEME_SETTINGS } from '@theme-settings';
import { isWalletDisabledForBetting } from '@utils/common/isWalletDisabledForBetting';

function isWalletForCurrentShop(
	wallet: UserAccount,
	store: UserAuthStore
): boolean {
	return (
		(wallet.shopId === store.defaultOnlineShopId ||
			wallet.shopId === store.activeShopUserShopId) &&
		(!THEME_SETTINGS.isDKMW ||
			(wallet.abrv !== UserAccountType.SportBettingAccountShopOnline &&
				wallet.isPrimary))
	);
}

function isNonSelectableWalletType(wallet: SelectableWallets): boolean {
	return (
		wallet.abrv === UserAccountType.SportBettingAccountShop ||
		wallet.abrv === UserAccountType.CasinoAccount ||
		wallet.abrv === UserAccountType.LiveCasinoAccount ||
		(wallet.abrv === UserAccountType.Games && !isGamesTheme())
	);
}

function isUserLockedFromWallet(
	wallet: SelectableWallets,
	store: UserAuthStore
): boolean {
	return store.secondaryUser == null && store.user?.id !== wallet.userId;
}

export function addCanBeSelected(store: UserAuthStore): SelectableWallets[] {
	if (!store.userAccounts) {
		return [];
	}

	const selectableWallets = store.userAccounts
		.filter((wallet) => isWalletForCurrentShop(wallet, store))
		.map((wallet) => {
			const selectableWallet: SelectableWallets = {
				...wallet,
				canBeSelected: true,
			};

			if (
				isNonSelectableWalletType(selectableWallet) ||
				isUserLockedFromWallet(selectableWallet, store) ||
				isWalletDisabledForBetting(selectableWallet)
			) {
				selectableWallet.canBeSelected = false;
			}

			return selectableWallet;
		});

	store.sortUserAccounts(selectableWallets);

	return selectableWallets;
}

export type SelectableWallets = UserAccount & { canBeSelected: boolean };
